export enum DictionaryLanguage {
  Russian = 'RUSSIAN',
  English = 'ENGLISH',
}

export type DictionaryLanguageTranslation = {
  [key in DictionaryLanguage]: string;
};

export type TranslationUnion = {
  translationUnionTag: string;
  translations: Array<DictionaryLanguageTranslation>;
  parentId?: string;
};
